<script lang="ts">
    import { inject, type Ref, type InjectionKey } from 'vue'

    type SiteNavType = 'accordion' | 'menu'

    type SiteNavItemContext = {
        value: Ref<string>
    }

    const key = Symbol() as InjectionKey<SiteNavItemContext>
    export const injectSiteNavItemContext = () => inject(key)
</script>
<script setup lang="ts">
    import { toRef, provide } from 'vue'
    import { injectSiteNavRootContext } from './site-nav-root.vue'
    import { AccordionItem, NavigationMenuItem } from 'radix-vue'

    const props = defineProps<{
        value: string
    }>()

    const value = toRef(props, 'value')

    provide(key, {
        value
    })

    const root = injectSiteNavRootContext()
</script>
<template>
    <AccordionItem as-child v-if="root.type.value === 'accordion'" :value>
        <li>
            <slot />
        </li>
    </AccordionItem>
    <NavigationMenuItem :value v-else>
        <slot />
    </NavigationMenuItem>
</template>